// eslint-disable-next-line
import moment from 'moment';

export function getDefaultSearchParams() {
    return {
        skuNameOrId: '',
        code: '',
        enquiryTime: null,
    };
}

export function getSearchFormFields() {
    return [
        {
            label: '商品名/skuId',
            slot: 'skuNameOrId',
        },
        {
            label: '询价单号',
            slot: 'code',
        },
        {
            label: '询价日期',
            model: 'enquiryTime',
            template: {
                tpl: 'xx-datepicker',
                attrs: {
                    editable: false,
                    valueFormat: 'timestamp',
                    type: 'daterange',
                    'default-time': ['00:00:00', '23:59:59'],
                    rangeSeparator: '-',
                    startPlaceholder: '开始日期',
                    endPlaceholder: '结束日期',
                },
            },
        },
    ];
}

export const parameterHandlerMapForListPage = new Map([
    [
        'enquiryTime',
        (data) => ({
            beginTime: data[0],
            endTime: data[1],
        }),
    ],
]);

export function getDefaultSearchParamsForDetailPage() {
    return {
        skuId: '',
        skuName: '',
    };
}

export const detailPageSearchParamsPipeMap = new Map([
    [
        'skuId',
        (value, filterValue) => {
            value += '';
            filterValue += '';
            if (!filterValue || !filterValue.trim()) return true;
            return value.indexOf(filterValue) !== -1;
        },
    ],
    [
        'skuName',
        (value, filterValue) => {
            value += '';
            filterValue += '';
            if (!filterValue || !filterValue.trim()) return true;
            return value.indexOf(filterValue) !== -1;
        },
    ],
]);

export function getSearchFormFieldsForDetailPage() {
    return [
        {
            label: 'skuId',
            slot: 'skuId',
        },
        {
            label: '商品名称',
            slot: 'skuName',
        },
    ];
}


export const TAB_PRICE_WAIT_REPORT = 'TAB_PRICE_WAIT_REPORT';
export const TAB_PRICE_REPORTED = 'TAB_PRICE_REPORTED';
export const TAB_PRICE_BARGAIN = 'TAB_PRICE_BARGAIN';
export const TAB_ENQUIRY_END = 'TAB_ENQUIRY_END';

export const TAB_CONTROLLER = new Map([
    [
        TAB_PRICE_WAIT_REPORT,
        {
            value: TAB_PRICE_WAIT_REPORT,
            label: '待报价',
            count: 0,
            state: 1,
        },
    ],
    [
        TAB_PRICE_REPORTED,
        {
            value: TAB_PRICE_REPORTED,
            label: '报价中',
            count: 0,
            state: 2,
        },
    ],
    [
        TAB_PRICE_BARGAIN,
        {
            value: TAB_PRICE_BARGAIN,
            label: '议价中',
            count: 0,
            state: 3,
        },
    ],
    [
        TAB_ENQUIRY_END,
        {
            value: TAB_ENQUIRY_END,
            label: '询价结束',
            count: 0,
            state: 4,
        },
    ],
]);

const getPriceWaitReportTableHeader = () => [
    {
        label: '序号',
        type: 'index',
        reserveIndex: true, // 添加配置reserveIndex=true时，翻页时序号将连续
    },
    {
        label: '询价单号',
        prop: 'code',
        'min-width': 100,
    },
    {
        label: '询价单标题',
        prop: 'title',
        'min-width': 100,
    },
    {
        label: '城市',
        prop: 'cityNames',
        'min-width': 100,
    },
    {
        label: '询价商品数量',
        prop: 'skuCount',
        'min-width': 100,
    },
    {
        label: '询价开始日期',
        prop: 'enquiryBeginTime',
        'min-width': 150,
    },
    {
        label: '询价结束日期',
        prop: 'enquiryEndTime',
        'min-width': 150,
    },
    {
        label: '询价人',
        prop: 'cname',
        'min-width': 100,
    },
    {
        label: '报价时间',
        prop: 'lastBidTime',
        'min-width': 150,
    },
    {
        label: '操作',
        prop: 'action',
        'min-width': 100,
        fixed: 'right',
    },
];

const getPriceReportedTableHeader = () => getPriceWaitReportTableHeader();

const getPriceBargainTableHeader = () => [
    {
        label: '序号',
        type: 'index',
        reserveIndex: true, // 添加配置reserveIndex=true时，翻页时序号将连续
    },
    {
        label: '询价单号',
        prop: 'code',
        'min-width': 100,
    },
    {
        label: '询价单标题',
        prop: 'title',
        'min-width': 100,
    },
    {
        label: '城市',
        prop: 'cityNames',
        'min-width': 100,
    },
    {
        label: '待确认议价商品数',
        prop: 'bargainSkuCount',
        'min-width': 100,
    },
    {
        label: '议价开始日期',
        prop: 'bargainBeginTime',
        'min-width': 150,
    },
    {
        label: '议价结束日期',
        prop: 'bargainEndTime',
        'min-width': 150,
    },
    {
        label: '询价人',
        prop: 'cname',
        'min-width': 100,
    },
    {
        label: '操作',
        prop: 'action',
        'min-width': 100,
        fixed: 'right',
    },
];

const getEnquiryEndTabletHeader = () => [
    {
        label: '序号',
        type: 'index',
        reserveIndex: true, // 添加配置reserveIndex=true时，翻页时序号将连续
    },
    {
        label: '询价单号',
        prop: 'code',
        'min-width': 100,
    },
    {
        label: '询价单标题',
        prop: 'title',
        'min-width': 100,
    },
    {
        label: '城市',
        prop: 'cityNames',
        'min-width': 100,
    },
    {
        label: '询价商品数量',
        prop: 'skuCount',
        'min-width': 100,
    },
    {
        label: '采纳商品数',
        prop: 'acceptSkuCount',
        'min-width': 100,
    },
    {
        label: '询价开始日期',
        prop: 'enquiryBeginTime',
        'min-width': 150,
    },
    {
        label: '询价结束日期',
        prop: 'enquiryEndTime',
        'min-width': 150,
    },
    {
        label: '询价人',
        prop: 'cname',
        'min-width': 100,
    },
    {
        label: '报价时间',
        prop: 'lastBidTime',
        'min-width': 150,
    },
    {
        label: '议价开始日期',
        prop: 'bargainBeginTime',
        'min-width': 150,
    },
    {
        label: '议价结束日期',
        prop: 'bargainEndTime',
        'min-width': 150,
    },
    {
        label: '操作',
        prop: 'action',
        'min-width': 100,
        fixed: 'right',
    },
];

export function getTabTableHeadersByType(type) {
    if (!TAB_CONTROLLER.has(type)) return [];
    switch (type) {
        case TAB_PRICE_WAIT_REPORT: {
            return getPriceWaitReportTableHeader();
        }
        case TAB_PRICE_REPORTED: {
            return getPriceReportedTableHeader();
        }
        case TAB_PRICE_BARGAIN: {
            return getPriceBargainTableHeader();
        }
        case TAB_ENQUIRY_END: {
            return getEnquiryEndTabletHeader();
        }
        default:
            break;
    }
    return [];
}

const help = '排名为实时排名信息，最终排名结果以报价结束的时间点为准';

const modeABHelp = 'A单（下单时间为10点，要求最晚当日20点完成大仓签到）、B单（下单时间为17点，要求最晚次日9点前完成大仓签到）';

// 待报价详情表头
const getPriceWaitReportDetailTableHeader = () => [
    {
        label: '序号',
        type: 'index',
        reserveIndex: true, // 添加配置reserveIndex=true时，翻页时序号将连续
    },
    {
        label: 'skuId',
        prop: 'skuId',
        'min-width': 100,
    },
    {
        label: '商品名称',
        prop: 'skuName',
        'min-width': 100,
    },
    {
        label: '规格',
        prop: 'format',
        'min-width': 100,
    },
    {
        label: '单位',
        prop: 'unit',
        'min-width': 100,
    },
    {
        label: '验收标准及描述',
        prop: 'standardDescription',
        'min-width': 110,
    },
    {
        label: '采购标准描述/备注',
        prop: 'description',
        'min-width': 160,
    },
    {
        label: '供货城市',
        prop: 'cityName',
        'min-width': 110,
    },
    {
        label: '报价排名',
        prop: 'priceRankStr',
        help,
        'min-width': 110,
    },
    {
        label: '报价方式',
        prop: 'style',
        'min-width': 110,
    },
    {
        label: '*单价（元）',
        prop: 'lastBidPrice',
        'min-width': 100,
    },
    {
        label: '建议零售价',
        prop: 'recommendPrice',
        'min-width': 100,
    },
    {
        label: '目标订货模式',
        prop: 'targetReplenishmentMode',
        'min-width': 100,
    },
    {
        label: '商支持订次',
        prop: 'replenishmentModeList',
        help: modeABHelp,
        'min-width': 100,
    },
    {
        label: '本期可供数量(pcs)',
        prop: 'supplyQuantity',
        'min-width': 140,
    },
    {
        label: '产地',
        prop: 'sourcePlace',
        'min-width': 100,
    },
    // {
    //     label: '供应商利润率',
    //     prop: 'profitMargin',
    //     'min-width': 110,
    //     help: '供应商利润率基于供应商采购价拆解,自动计算',
    // },
    // 拆解前端隐藏，后续产品会迭代加回来
    // {
    //     label: '报价拆解',
    //     prop: 'bomPrice',
    //     'min-width': 100,
    // },
    {
        label: '商家补充描述',
        prop: 'remark',
        'min-width': 100,
    },
    {
        label: '最后报价时间',
        prop: 'lastBidTime',
        'min-width': 150,
    },
];
// 报价中详情表头
const getPriceReportedDetailTableHeader = () => [
    {
        label: '序号',
        type: 'index',
        reserveIndex: true,
    },
    {
        label: 'skuId',
        prop: 'skuId',
        'min-width': 100,
    },
    {
        label: '商品名称',
        prop: 'skuName',
        'min-width': 100,
    },
    {
        label: '规格',
        prop: 'format',
        'min-width': 80,
    },
    {
        label: '单位',
        prop: 'unit',
        'min-width': 80,
    },
    {
        label: '验收标准及描述',
        prop: 'standardDescription',
        'min-width': 110,
    },
    {
        label: '采购标准描述/备注',
        prop: 'description',
        'min-width': 160,
    },
    {
        label: '供货城市',
        prop: 'cityName',
        'min-width': 110,
    },
    {
        label: '报价排名',
        prop: 'priceRankStr',
        help,
        'min-width': 110,
    },
    {
        label: '报价方式',
        prop: 'style',
        'min-width': 110,
    },
    {
        label: '*单价（元）',
        prop: 'lastBidPrice',
        'min-width': 100,
    },
    {
        label: '建议零售价',
        prop: 'recommendPrice',
        'min-width': 100,
    },
    {
        label: '目标订货模式',
        prop: 'targetReplenishmentMode',
        'min-width': 100,
    },
    {
        label: '商支持订次',
        prop: 'replenishmentModeList',
        help: modeABHelp,
        'min-width': 100,
    },
    {
        label: '本期可供数量(pcs)',
        prop: 'supplyQuantity',
        'min-width': 140,
    },
    {
        label: '产地',
        prop: 'sourcePlace',
        'min-width': 100,
    },
    // {
    //     label: '供应商利润率',
    //     prop: 'profitMargin',
    //     'min-width': 110,
    //     help: '供应商利润率基于供应商采购价拆解,自动计算',
    // },
    // 拆解前端隐藏，后续产品会迭代加回来
    // {
    //     label: '报价拆解',
    //     prop: 'bomPrice',
    //     'min-width': 100,
    // },
    {
        label: '商家补充描述',
        prop: 'remark',
        'min-width': 100,
    },
    {
        label: '最后报价时间',
        prop: 'lastBidTime',
        'min-width': 150,
    },
];
// 议价中详情表头
const getPriceBargainDetailTableHeader = () => [
    {
        label: '序号',
        type: 'index',
        reserveIndex: true, // 添加配置reserveIndex=true时，翻页时序号将连续
    },
    {
        label: 'skuId',
        prop: 'skuId',
        'min-width': 100,
        allowSpanRow: true,
    },
    {
        label: '商品名称',
        prop: 'skuName',
        'min-width': 100,
        allowSpanRow: true,
    },
    {
        label: '规格',
        prop: 'format',
        'min-width': 100,
        allowSpanRow: true,
    },
    {
        label: '单位',
        prop: 'unit',
        'min-width': 100,
        allowSpanRow: true,
    },
    {
        label: '验收标准及描述',
        prop: 'standardDescription',
        'min-width': 110,
        allowSpanRow: true,
    },
    {
        label: '采购标准描述/备注',
        prop: 'description',
        'min-width': 160,
        allowSpanRow: true,
    },
    {
        label: '供货城市',
        prop: 'cityName',
        'min-width': 110,
        allowSpanRow: true,
    },
    {
        label: '报价排名',
        prop: 'priceRankStr',
        help,
        'min-width': 110,
    },
    {
        label: '*单价（元）',
        prop: 'lastBidPrice',
        'min-width': 100,
    },
    {
        label: '建议零售价',
        prop: 'recommendPrice',
        'min-width': 100,
    },
    {
        label: '目标订货模式',
        prop: 'targetReplenishmentMode',
        'min-width': 100,
    },
    {
        label: '商支持订次',
        prop: 'replenishmentModeList',
        help: modeABHelp,
        'min-width': 100,
    },
    {
        label: '本期可供数量(pcs)',
        prop: 'supplyQuantity',
        'min-width': 140,
    },
    {
        label: '产地',
        prop: 'sourcePlace',
        'min-width': 100,
    },
    // {
    //     label: '供应商利润率',
    //     prop: 'profitMargin',
    //     'min-width': 110,
    //     help: '供应商利润率基于供应商采购价拆解,自动计算',
    // },
    // 拆解前端隐藏，后续产品会迭代加回来
    // {
    //     label: '报价拆解',
    //     prop: 'bomPrice',
    //     'min-width': 100,
    // },
    {
        label: '议价价格',
        prop: 'bargainPrice',
        'min-width': 100,
    },
    {
        label: '议价是否接受',
        prop: 'bargainState',
        'min-width': 250,
    },
];
// 询价结束
const getEnquiryEndDetailTabletHeader = () => [
    {
        label: '序号',
        type: 'index',
        reserveIndex: true, // 添加配置reserveIndex=true时，翻页时序号将连续
    },
    {
        label: 'skuId',
        prop: 'skuId',
        'min-width': 100,
        allowSpanRow: true,
    },
    {
        label: '商品名称',
        prop: 'skuName',
        'min-width': 100,
        allowSpanRow: true,
    },
    {
        label: '规格',
        prop: 'format',
        'min-width': 100,
        allowSpanRow: true,
    },
    {
        label: '单位',
        prop: 'unit',
        'min-width': 100,
        allowSpanRow: true,
    },
    {
        label: '采购标准描述/备注',
        prop: 'description',
        'min-width': 160,
        allowSpanRow: true,
    },
    {
        label: '供货城市',
        prop: 'cityName',
        'min-width': 110,
        allowSpanRow: true,
    },
    {
        label: '报价排名',
        prop: 'priceRankStr',
        help,
        'min-width': 110,
    },
    {
        label: '*单价（元）',
        prop: 'lastBidPrice',
        'min-width': 100,
    },
    {
        label: '建议零售价',
        prop: 'recommendPrice',
        'min-width': 100,
    },
    {
        label: '目标订货模式',
        prop: 'targetReplenishmentMode',
        'min-width': 100,
    },
    {
        label: '商支持订次',
        prop: 'replenishmentModeList',
        help: modeABHelp,
        'min-width': 100,
    },
    {
        label: '本期可供数量(pcs)',
        prop: 'supplyQuantity',
        'min-width': 140,
    },
    {
        label: '议价价格',
        prop: 'bargainPrice',
        'min-width': 100,
    },
    {
        label: '议价是否接受',
        prop: 'bargainState',
        'min-width': 250,
    },
    {
        label: '是否采纳',
        prop: 'accept',
        'min-width': 100,
        template: {
            tpl: 'enum',
            list: [
                { label: '未采纳', value: 0 },
                { label: '已采纳', value: 1 },
            ],
        },
    },
    {
        label: '采纳价(元)',
        prop: 'acceptPrice',
        'min-width': 100,
    },
    {
        label: '采纳时间',
        prop: 'acceptTime',
        'min-width': 150,
    },
    {
        label: '商家补充描述',
        prop: 'remark',
        'min-width': 100,
    },
];
// 询价结束
export function getDetailPageTableHeaderByType(type) {
    if (!TAB_CONTROLLER.has(type)) return [];
    switch (type) {
        case TAB_PRICE_WAIT_REPORT: {
            return getPriceWaitReportDetailTableHeader();
        }
        case TAB_PRICE_REPORTED: {
            return getPriceReportedDetailTableHeader();
        }
        case TAB_PRICE_BARGAIN: {
            return getPriceBargainDetailTableHeader();
        }
        case TAB_ENQUIRY_END: {
            return getEnquiryEndDetailTabletHeader();
        }
        default:
            break;
    }
    return [];
}

export function formatTimeHelper(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
    if (timestamp > 0) {
        return moment(timestamp).format(format);
    }
    return '--';
}

export const enquiryEnumMap = {
    1: '手动询价',
    2: '自动询价',
};

export const productInfoTruncateLengthMap = new Map([
    ['cityNames', 15],
    ['title', 12],
]);

// 报价异常提示表格配置
export const priceExceptionInfoColumns = [
    {
        label: '序号',
        type: 'index',
        reserveIndex: true,
    },
    {
        label: 'skuId',
        prop: 'skuId',
        'min-width': 100,
    },
    {
        label: '商品名称',
        prop: 'skuName',
        'min-width': 100,
    },
    {
        label: '规格',
        prop: 'spec',
        'min-width': 70,
    },
    {
        label: '单位',
        prop: 'unit',
        'min-width': 100,
    },
    {
        label: '本次报价(元)',
        prop: 'price',
        'min-width': 100,
    },
];

export const bomInputTableHeader = [
    'lastBidPrice',
    'recommendPrice',
    'bomPrice',
];

// 验收标准及描述弹窗表格配置
export function getStandardDescriptionColumn() {
    return [
        {
            label: '序号',
            type: 'index',
            reserveIndex: true,
        },
        {
            label: '指标名称',
            prop: 'indicatorName',
            'min-width': 100,
        },
        {
            label: '指标描述',
            prop: 'indicatorRemark',
            'min-width': 100,
        },
        {
            label: '图片',
            prop: 'indicatorPicture',
            'min-width': 70,
        },
    ];
}

// bom成本项正则校验-大于等于0的数字，小数点不超过两位
export const bomPricePattern = /^(0|[1-9]\d*(\.\d{1,2})?|([0](\.([0][1-9]|[1-9]\d{0,1}))))$/;

/**  议价价格空值判断 */
export const hasPriceCheck = (price) => String(price) === '0' || (price !== null && price !== undefined && price !== '');

// 议价是否接受
export const bargainStateEnumMap = {
    accept: 1, // 接受
    reject: 2, // 拒绝
};

export const valueTypeEnumMap = {
    0: '元',
    1: '%',
    2: '千米',
};
export const unitTypeEnumMap = {
    0: 'KG',
    1: '份',
    2: 'KG·千米',
    3: '-',
};

/** 报价方式：1 统一 2 分城 */
export const REPORT_TYPE = {
    DIFFERENTIATE: 0,
    UNIFY: 1,
};

export const targetReplenishmentModeMap = {
    1: '一订模式',
    2: '两订模式',
};
